
class DraftStore {
    constructor() {

    }
    //取本地草稿数据
    // async loadData=()=>{

    // }

} 

export default DraftStore;